import OSS from "ali-oss";
import { getOssUploadRole } from "@/api";
import { FileUtil } from "@/util";
import { buildObjectKey } from "@/constants/ossPath";

const clientMap = {};

export default {
  async getOssClient(bucket) {
    if (clientMap[bucket]) {
      const { expiration } = clientMap[bucket].stsCredentials;
      const expireDate = new Date(expiration);
      // 如果过期时间大于3分钟，则无需替换凭证
      if (expireDate.getTime() - new Date().getTime() > 3 * 60 * 1000) {
        return clientMap[bucket].client;
      }
    }

    const res = await getOssUploadRole();
    const stsCredentials = res.data.credentials;
    const { accessKeyId, accessKeySecret, securityToken } = stsCredentials;

    const client = new OSS({
      accessKeyId,
      accessKeySecret,
      secure: true,
      stsToken: securityToken,
      bucket
    });

    clientMap[bucket] = {
      stsCredentials,
      client
    };

    return client;
  },

  async deleteFile(bucket, filePath, url) {
    let objectKey = "";
    try {
      objectKey = decodeURIComponent(new URL(url).pathname.replace(/^\/+/, ""));
    } catch (e) {
      objectKey = buildObjectKey(filePath, FileUtil.getFileName(url));
    }
    if (!objectKey) {
      return;
    }
    const client = await this.getOssClient(bucket);
    await client.delete(objectKey);
  }
};
